'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editor", "open", "target", "onRemove", "onVideoReplace", "onVideoRemove", "onEditDetails", "onOpenCtaPicker", "onUpdateConversionAsset", "onUpdateVideoParams", "onOpenConversionAssetPanel"];
import PropTypes from 'prop-types';
import VideoPopoverBodyBranch from 'rich-text-lib/components/video/VideoPopoverBodyBranch';
import { PopoverBodyMode } from 'rich-text-lib/constants/popover';
import TinyMcePopover from './TinyMcePopover';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  editor: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  target: PropTypes.object,
  mode: PropTypes.oneOf(Object.keys(PopoverBodyMode).map(key => PopoverBodyMode[key])),
  onRemove: PropTypes.func.isRequired,
  onVideoReplace: PropTypes.func.isRequired,
  onVideoRemove: PropTypes.func.isRequired,
  onEditDetails: PropTypes.func.isRequired,
  onOpenCtaPicker: PropTypes.func.isRequired,
  onUpdateConversionAsset: PropTypes.func.isRequired,
  onUpdateVideoParams: PropTypes.func.isRequired,
  onOpenConversionAssetPanel: PropTypes.func.isRequired
};
function VideoPopoverV2(props) {
  const {
      editor,
      open,
      target,
      onRemove,
      onVideoReplace,
      onVideoRemove,
      onEditDetails,
      onOpenCtaPicker,
      onUpdateConversionAsset,
      onUpdateVideoParams,
      onOpenConversionAssetPanel
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(TinyMcePopover, {
    "data-test-id": "video-popover-manager",
    editor: editor,
    open: open,
    target: target,
    onRemove: onRemove,
    placement: props.mode === PopoverBodyMode.PREVIEW ? 'bottom' : 'right',
    content: /*#__PURE__*/_jsx(VideoPopoverBodyBranch, Object.assign({}, rest, {
      onVideoReplace: onVideoReplace.bind(null, target),
      onVideoRemove: onVideoRemove.bind(null, target),
      onOpenVideoDetails: onEditDetails.bind(null, target),
      onOpenCtaPicker: onOpenCtaPicker.bind(null, target),
      onUpdateConversionAsset: onUpdateConversionAsset.bind(null, target),
      onUpdateVideoParams: onUpdateVideoParams.bind(null, target),
      onOpenConversionAssetPanel: onOpenConversionAssetPanel ? onOpenConversionAssetPanel.bind(null, target) : null,
      dropdownClassName: "mce-ui-select"
    }))
  });
}
VideoPopoverV2.propTypes = propTypes;
VideoPopoverV2.displayName = 'VideoPopoverV2';
export default VideoPopoverV2;